(() => {
  function init(){
    document.querySelectorAll('[data-ps-newsletter-popup]').forEach(dialog=>{
      if(dialog.dataset.initialized)return;dialog.dataset.initialized='true';
      let timer;
      function seen(){try{return sessionStorage.getItem('ps-newsletter-seen')==='yes';}catch{return false;}}
      function remember(){try{sessionStorage.setItem('ps-newsletter-seen','yes');}catch{}}
      function open(){if(dialog.open||!dialog.isConnected)return;if(document.querySelector('dialog[open]'))return;dialog.showModal();remember();}
      function close(){dialog.close();remember();clearTimeout(timer);}
      dialog.querySelectorAll('[data-ps-newsletter-close]').forEach(button=>button.addEventListener('click',close));
      dialog.addEventListener('close',()=>{remember();clearTimeout(timer);});
      dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();});
      document.querySelectorAll('[data-ps-newsletter-open]').forEach(button=>button.addEventListener('click',()=>{clearTimeout(timer);open();}));
      if(dialog.querySelector('[data-ps-newsletter-result]')){open();}
      else if(!seen()){timer=setTimeout(()=>{if(document.hidden||document.querySelector('dialog[open]'))return;open();},Number(dialog.dataset.delay)||9000);}
    });
  }
  init();document.addEventListener('shopify:section:load',init);
})();
